import { render, staticRenderFns } from "./MarketCart.vue?vue&type=template&id=380f243c&"
import script from "./MarketCart.vue?vue&type=script&lang=js&"
export * from "./MarketCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports